import { canActivateEducation, EDUCATION_VOTING_PRODUCT, type EducationEligibility } from "./education.ts";
import { canManageWorkspace, workspaceKey, type ProductWorkspace } from "./workspaces.ts";

/** Presentation follows exact server workspaces; it never grants access. */
export function productWorkspaces(items: ProductWorkspace[], productId: string, now = Date.now()): ProductWorkspace[] {
  const unique = new Map<string, ProductWorkspace>();
  for (const item of items) {
    if (item.serviceProductId === productId && canManageWorkspace(item, now)) unique.set(workspaceKey(item), item);
  }
  return [...unique.values()];
}

/** Only the current organization's explicit, active lifetime entitlement suppresses a repeat purchase. */
export function hasLifetimeSubscription(items: ProductWorkspace[], productId: string, organizationId?: string): boolean {
  return !!organizationId && items.some(item => item.organizerId === organizationId && item.serviceProductId === productId &&
    item.enabled && item.subscriptionStatus === "ACTIVE" && item.accessMode !== "VIEW_ONLY" &&
    item.freeForLife === true && item.expiresAtEpochMillis === null);
}

export function additionalActivationChoices(items: EducationEligibility[], owned: ProductWorkspace[]): EducationEligibility[] {
  const ownedOrganizations = new Set(owned.filter((item) => item.serviceProductId === EDUCATION_VOTING_PRODUCT).map((item) => item.organizerId));
  return items.filter((item) => canActivateEducation(item) && !ownedOrganizations.has(item.organizerId));
}

export function catalogEmptyState(itemCount: number, filter: string, cursor: string): "search" | "page" | "catalog" | null {
  if (itemCount) return null;
  return filter ? "search" : cursor ? "page" : "catalog";
}
